import { render } from "./FlowTemplatesPage.vue?vue&type=template&id=995b81c4"
import script from "./FlowTemplatesPage.vue?vue&type=script&lang=js"
export * from "./FlowTemplatesPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__